import salesAnalysis from "@/pages/home/assets/img/studio/sales-analysis.png";
import bundleDlcSales from "@/pages/home/assets/img/studio/bundle-dlc-sales.png";
import refundAnalysis from "@/pages/home/assets/img/studio/refund-analysis.png";
import wishlistAnalysis from "@/pages/home/assets/img/studio/wishlist-analysis.png";
import eventAnalysis from "@/pages/home/assets/img/studio/event-analysis.png";
import eventComparison from "@/pages/home/assets/img/studio/event-comparison.png";
import commercialAnalysis from "@/pages/home/assets/img/studio/commercial-analysis.png";
import gameplayAnalysis from "@/pages/home/assets/img/studio/gameplay-analysis.png";
import operationAnalysis from "@/pages/home/assets/img/studio/operation-analysis.png";
import campaignMonitor from "@/pages/home/assets/img/studio/campaign-monitor.png";
import experimentTracking from "@/pages/home/assets/img/studio/experiment-tracking.png";
import weeklySentiment from "@/pages/home/assets/img/studio/weekly-sentiment.png";
import uaWeekly from "@/pages/home/assets/img/studio/ua-weekly.png";



const imageMap: Record<string, string> = {
  salesAnalysis,
  bundleDlcSales,
  refundAnalysis,
  wishlistAnalysis,
  eventAnalysis,
  eventComparison,
  commercialAnalysis,
  gameplayAnalysis,
  operationAnalysis,
  campaignMonitor,
  experimentTracking,
  weeklySentiment,
  uaWeekly
};

export function getImageByKey(key: string): string {
  return imageMap[key] || key;
}